interface BubbleProps {
  isOpen: boolean;
  position: "bottom-right" | "bottom-left";
  onClick: () => void;
  openLabel?: string;
  closeLabel?: string;
}

export function Bubble({ isOpen, position, onClick, openLabel, closeLabel }: BubbleProps) {
  return (
    <button
      className={`prc-widget-bubble prc-widget-bubble--${position} ${isOpen ? "prc-widget-bubble--open" : ""}`}
      onClick={onClick}
      aria-label={isOpen ? closeLabel || "Close chat" : openLabel || "Open chat"}
      aria-expanded={isOpen}
      aria-controls="promptrails-chat-panel"
      part="launcher"
    >
      {isOpen ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
        </svg>
      )}
    </button>
  );
}
